/**
 * Employees data fixtures shared by all ListView tests
 */

export type Employee<K> = {
  id: K;
  name: string;
};

export function populateData(
  count: number,
  isNumberKey?: boolean
): Employee<string>[] | Employee<number>[] {
  const data = [];
  for (let i = 0; i < count; i++) {
    if (isNumberKey) {
      data.push({ id: i, name: 'Employee ' + i });
    } else {
      data.push({ id: 'i' + i, name: 'Employee ' + i });
    }
  }
  return isNumberKey ? (data as Employee<number>[]) : (data as Employee<string>[]);
}
